export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden pt-[72px]">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-line"></i>
              <span>全本免费 · 下拉阅读</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              迷妹漫画 · 免费漫画阅读乐园
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading font-medium mb-6">
              日韩热门国漫精品，随时随地畅享阅读
            </p>

            <div className="max-w-xl mx-auto lg:mx-0">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                迷妹漫画专注提供海量免费漫画资源，覆盖日本漫画、韩国漫画和国产漫画全品类，支持下拉式竖屏滚动阅读体验。
                平台每日稳定更新连载内容，全本完结作品一键畅读，无需注册即可零花费享受超清画质。
                无论你是日漫死忠、韩漫爱好者还是国漫追随者，迷妹漫画都是你随身携带的免费漫画阅读乐园。
              </p>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-refresh-line text-accent-600 text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-600">每日稳定更新</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-global-line text-accent-600 text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-600">日韩国漫全覆盖</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                    <i className="ri-check-double-line text-accent-600 text-sm"></i>
                  </div>
                  <span className="text-sm text-foreground-600">全本完结免费看</span>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#cards"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-book-open-line"></i>
                  开始阅读
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-foreground-700 font-medium rounded-full border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-line"></i>
                  下载APP
                </a>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[300px] h-[360px] md:w-[420px] md:h-[480px] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20illustration%20of%20a%20cozy%20manga%20reading%20environment%20with%20floating%20comic%20panels%20and%20speech%20bubbles%20in%20soft%20coral%20and%20cream%20tones%2C%20stylized%20Japanese%20manga%20aesthetic%20with%20modern%20flat%20design%20elements%2C%20gentle%20gradient%20background%20transitioning%20from%20warm%20peach%20to%20light%20ivory%2C%20clean%20composition%20with%20ample%20negative%20space%2C%20digital%20art%20style%20with%20subtle%20texture%20overlay%2C%20harmonious%20and%20inviting%20atmosphere%20for%20comic%20enthusiasts&width=840&height=960&seq=hero-manga-01&orientation=portrait"
                alt="迷妹漫画阅读场景插画"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}